// extracted by mini-css-extract-plugin
module.exports = {"markPrice":"Prices_markPrice__0u5lf"};